const TYPE = 'REGISTRATION_SET_DATA';

const action = (data) => (dispatch) => dispatch({ type: TYPE, payload: data });

export default { action, TYPE };
